// ============================================
// FILE: apiSetup/apiConfig.ts
// ============================================

import { isBeta } from '../config/env';

let API_BASE_URL: string;

if (isBeta) {
  API_BASE_URL = 'https://beta-skoolpillar-api.skoolpillar.com/';
} else if (process.env.NODE_ENV === 'production') {
  API_BASE_URL = 'https://skoolpillar-api.skoolpillar.com/';
} else {

  // url that connects to the localhost
  
  API_BASE_URL = 'https://dev-api.skoolpillar.cloud/';
  // API_BASE_URL = 'https://beta-skoolpillar-api.skoolpillar.com/';

}

export { API_BASE_URL };


